import React, { useContext } from 'react';
import { EllipsisOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps, Modal } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import DeviceContext from '@totem/components/devices/devicesContainer/deviceContainerContext';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DeviceQueryResult } from '@totem/types/devices';

type Props = {
  device: DeviceQueryResult;
};

const DeviceActionMenu = ({ device }: Props) => {
  const { userProfile } = useContext(UserProfileContext);
  const { onAction } = useContext(DeviceContext);

  const handleRemoveDevice = () => {
    Modal.confirm({
      title: `Do you want to delete this device: ${device.device.displayName}?`,
      content: 'This action cannot be undone.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: () => onAction('RemoveDevice', device),
      onCancel: () => {},
    });
  };

  const getActionMenuItems = (): MenuProps['items'] => {
    const menuItems: MenuProps['items'] = [];

    if (permissions.organizationalAdministrator.hasPermissions(userProfile)) {
      menuItems.push({
        key: 'set_association',
        label: (
          <IBTooltip content={permissions.organizationalAdministrator.tooltip}>
            Set Association
          </IBTooltip>
        ),
        title: 'Set Association',
        icon: <MenuUnfoldOutlined />,
      });
    }

    if (permissions.systemAdministrator.hasPermissions(userProfile)) {
      menuItems.push({
        key: 'remove_device',
        label: (
          <IBTooltip content={permissions.systemAdministrator.tooltip}>
            Remove Device
          </IBTooltip>
        ),
        title: 'Remove Device',
        icon: <MenuUnfoldOutlined />,
      });
    }

    return menuItems;
  };

  const onMenuClicked = ({ key }) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'set_association':
        onAction('ShowReferenceModal', device);
        break;
      case 'remove_device':
        handleRemoveDevice();
        break;
    }
  };

  return (
    <Dropdown
      menu={{ items: getActionMenuItems(), onClick: onMenuClicked }}
      trigger={['click']}
    >
      <Button shape="circle" icon={<EllipsisOutlined />} />
    </Dropdown>
  );
};

export default DeviceActionMenu;
